import * as React from 'react';
import { IconDelivery, IconPlate, IconToGo, IconWineGlass } from '@tock/icons';
import {
  IconDelivery as IconDeliveryLegacy,
  IconDeliveryScooter,
  IconPrivateDining,
  IconWineGlass as IconWineGlassLegacy,
} from 'ui/icons';
import { consumer } from '@tock/coretypes';
import { deliveryServiceProviderDisplayName } from '@tock/shared/utils/offerings';
import { getSizeContent, getTypeContent } from 'utils/experience';
import { useIsSakeIconSetEnabled } from 'omakase/utils/IconMigrationUtil';
import OfferingDetailsMetadataItem from 'components/business/offering/OfferingDetailsMetadataItem';

interface Props {
  offering: consumer.Offering;
  businessType?: string;
}

const OfferingDetailsType: React.FunctionComponent<Props> = ({ offering, businessType }) => {
  const isSakeIconSetEnabled = useIsSakeIconSetEnabled();

  let icon;
  switch (offering.type) {
    case 'ORDER_DELIVERY':
      icon = isSakeIconSetEnabled ? IconDelivery : IconDeliveryScooter;
      break;

    case 'ORDER_PICKUP':
      icon = isSakeIconSetEnabled ? IconToGo : IconDeliveryLegacy;
      break;

    default:
      icon =
        businessType === 'Winery'
          ? isSakeIconSetEnabled
            ? IconWineGlass
            : IconWineGlassLegacy
          : isSakeIconSetEnabled
            ? IconPlate
            : IconPrivateDining;
      break;
  }

  let typeContent = getTypeContent(
    offering.type,
    offering.purchaseSize,
    offering.descriptiveVariety,
    offering.singleUnitQuantity
  );
  const sizeContent = getSizeContent(offering.type, offering.purchaseSize);

  if (offering.type === 'ORDER_DELIVERY' && offering.deliveryServiceProvider !== 'INTERNAL') {
    typeContent = (
      <>{`${deliveryServiceProviderDisplayName(offering.deliveryServiceProvider)} delivery`}</>
    );
  }

  return (
    <OfferingDetailsMetadataItem icon={icon} data-testid="offering-details">
      {typeContent}
      {sizeContent}
    </OfferingDetailsMetadataItem>
  );
};

export default OfferingDetailsType;
